<script setup lang="ts">
import { ref } from 'vue'
import Activity from './components/Activity.vue'
import ActivityCheckIn from '../home/components/ActivityCheckIn.vue'
import { useUserStore } from '@/stores/modules/user'
import Gift from './components/Gift.vue'

const userStore = useUserStore()

const curTab = ref('activity')
</script>

<template>
  <div class="one-year-page page">
    <h2 style="margin-bottom: 5px">新春特典</h2>
    <p style="font-size: 12px; margin: 0 0 10px 0; text-align: center">2026-03-08 00:00:00 结束</p>
    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="活动" name="activity" class="pane">
        <Activity class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="签到" name="checkIn" class="pane" lazy>
        <ActivityCheckIn class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="福利" name="gift" class="pane" lazy v-if="userStore.vipLevel || userStore.crystal > 0">
        <Gift class="pane-item" />
      </el-tab-pane>
    </el-tabs>

    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.one-year-page {
  padding-top: 0;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: hidden;
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: auto;
            display: flex;
            flex-flow: column nowrap;
          }
        }
      }
    }
  }
}
</style>
